import React, { FC, ReactElement } from 'react';
import { Checkmark } from 'grommet-icons';
import { Box } from 'grommet';
import { BoxExtendedProps } from 'grommet/components/Box';

// TODO: Extend to support different colors and sizes
export const BulletCheck: FC<BoxExtendedProps> = ({
  background = `status-ok`,
  color = `white`,
  ...rest
}): ReactElement => (
  <Box
    flex={false}
    background={background}
    round="full"
    height="18px"
    width="18px"
    align="center"
    justify="center"
    {...rest}
  >
    <Checkmark color={color} size="small" />
  </Box>
);
